/* eslint-disable no-empty-function */
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DrawerCategory from './DrawerCategory';
import { DrawerContainer, DrawerContent } from './MobileDrawer.styles';
import { mobileDrawerPropTypes } from './MobileDrawer.propTypes';
import Button from '../button/button';

/**
 * PropTypes for the MobileDrawer component.
 *
 * Categories: Object containing category, menu & submenu
 *
 * Width: Width of the menu drawer
 */

const MobileDrawer = ({ categories, width, actions, newOpen, onClose }) => {
  const toggleDrawer = newOpen => () => {
    onClose(newOpen);
  };
  

  return (
    <Box>
      <Drawer
        open={newOpen}
        onClose={onClose}
        PaperProps={{ sx: { backgroundColor: '#EBEEF2' } }}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        <DrawerContainer sx={{ width }}>
          <DrawerContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 0.4,
                marginBottom: '40px',
                fontFamily: 'body.fontFamily.secondary',
              }}
            >
              <IconButton
                onClick={toggleDrawer(false)}
                aria-label="Close Drawer"
              >
                <CloseIcon sx={{ color: 'primary.main', width: '22px' }} />
              </IconButton>
            </Box>
            {categories.map((categories, index) => (
              <DrawerCategory
                key={categories?.name}
                category={categories}
                index={index}
                actions={actions} // Pass Frontity actions to DrawerCategory
                closeDrawer={toggleDrawer(false)}
              />
            ))}
           
          </DrawerContent>
        </DrawerContainer>
      </Drawer>
    </Box>
  );
};

MobileDrawer.propTypes = mobileDrawerPropTypes;

export default MobileDrawer;
